import { QUOTES } from "../../data/content";

export const Testimonials = () => (
  <section
    data-testid="testimonials-section"
    className="py-24 bg-neutral-900 border-b border-neutral-800"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="mb-8">
        <h2 className="font-display text-2xl font-black uppercase text-white">
          Le parole del Finnico
        </h2>
        <p className="text-sm text-neutral-400 mt-1">
          Citazioni di Davide Bolognesi, fondatore del Legend Team, tratte dal documento ufficiale.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {QUOTES.map((t, i) => (
          <blockquote
            key={t.context}
            data-testid={`testimonial-${i + 1}`}
            className="p-6 bg-neutral-950 border border-neutral-800 border-t-2 border-t-red-600 flex flex-col justify-between"
          >
            <p className="text-sm text-neutral-200 italic leading-relaxed mb-5">"{t.quote}"</p>
            <footer>
              <span className="mono-label text-xs text-red-500 block uppercase">Davide Bolognesi</span>
              <span className="mono-label text-[10px] text-neutral-500 block uppercase mt-0.5">
                {t.context}
              </span>
            </footer>
          </blockquote>
        ))}
      </div>
    </div>
  </section>
);
